import { useSelector } from 'react-redux'
import { botHostingMetadataSelector } from '../selectors/botHostingMetadataSelector'

export function useSdkBuildInfo() {
  return useSelector(botHostingMetadataSelector)?.buildInfo
}
